<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <checkout />
    </div>
  </div>
</template>
<script>
import Checkout from '../components/Checkout.vue';

export default {
    components: {
        Checkout
    },
}
</script>
